/**
 * ck-nav - Steuerung der Hauptnavigation.
 *
 * Bewusst klein, ohne Abhängigkeiten, ohne moderne Syntax (kein ?., kein
 * let/const), damit auch ältere Safari- und Android-Browser mitkommen.
 * Die Links stehen alle im HTML; dieses Skript regelt nur das Auf und Zu,
 * die Tastaturbedienung und den Wechsel der Ebenen in der Schublade.
 *
 * WICHTIG: Alle Ereignisse hängen am Dokument, nicht an den Menüpunkten.
 * Das Theme klont die Kopfzeile für die mitlaufende Leiste beim Scrollen;
 * an einzelne Elemente gebundene Ereignisse wären in diesem Klon verloren.
 *
 * Ohne JavaScript bleibt die Navigation benutzbar: jeder oberste Punkt der
 * Leiste ist ein echter Link auf seine Übersichtsseite. Suchmaschinen sehen
 * ohnehin das vollständige Markup, die Ebenen sind nur unsichtbar.
 */
(function () {
  'use strict';

  if (!document.documentElement.closest) return; // sehr alte Browser: Links funktionieren trotzdem

  var OFFEN = 'cknav__item--offen';
  var NACHLAUF = 180; // ms, damit der Weg vom Menüpunkt zum Panel nicht abreisst
  var schliessZeit = null;
  var zeigerIstMaus = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };

  function naechster(ziel, selektor) {
    return ziel && ziel.closest ? ziel.closest(selektor) : null;
  }

  function fokus(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  /* =====================================================================
     Leiste (Desktop)
     ===================================================================== */

  function alleSchliessen(ausser) {
    var offene = document.querySelectorAll('.' + OFFEN);
    for (var i = 0; i < offene.length; i += 1) {
      if (offene[i] === ausser) continue;
      offene[i].classList.remove(OFFEN);
      var t = offene[i].querySelector('[data-cknav-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  }

  /**
   * Panel waagerecht ausrichten: mittig unter seinem Menüpunkt, aber nie
   * über den Bildschirmrand hinaus. Bezugspunkt ist die Leiste, denn ein
   * breites Panel an einem schmalen Menüpunkt läuft sonst aus dem Bild.
   */
  function richteAus(item) {
    var panel = item.querySelector('.cknav__panel');
    var leiste = item.closest('.cknav');
    if (!panel || !leiste) return;

    // Zwei Bezugsrahmen: die Reihe der Menüpunkte (meist mittig gesetzt) und
    // der Inhaltscontainer der Kopfzeile, in dem Logo und Suche stehen.
    var reihe = leiste.getBoundingClientRect();
    var traeger = leiste.parentElement ? leiste.parentElement.getBoundingClientRect() : reihe;
    var luft = 16;

    // Deckel: nie breiter als der Container, nie breiter als das Fenster.
    var deckel = Math.min(1200, traeger.width, window.innerWidth - 2 * luft);
    panel.style.setProperty('--ck-panel-max', Math.round(deckel) + 'px');
    panel.style.setProperty('--ck-panel-x', '0px');

    var breite = panel.offsetWidth;
    var punkt = item.getBoundingClientRect();
    var wunsch = punkt.left + punkt.width / 2 - breite / 2;

    // 1. Wahl: mittig unter dem Menüpunkt, aber nicht links der Reihe und
    //    nicht rechts aus dem Container.
    // 2. Wahl: passt das nicht, darf es bis an den linken Containerrand.
    // 3. Wahl: breiter als der Container, dann mittig im Fenster.
    var kleinstes = Math.max(luft, reihe.left);
    var groesstes = Math.min(window.innerWidth - breite - luft, traeger.right - breite);
    if (groesstes < kleinstes) kleinstes = Math.max(luft, traeger.left);
    var x;
    if (groesstes < kleinstes) {
      x = Math.max(luft, (window.innerWidth - breite) / 2);
    } else {
      x = Math.max(kleinstes, Math.min(wunsch, groesstes));
    }

    panel.style.setProperty('--ck-panel-x', Math.round(x - reihe.left) + 'px');
  }

  function oeffne(item) {
    if (item.classList.contains(OFFEN)) return;
    alleSchliessen(item);
    item.classList.add(OFFEN);
    var t = item.querySelector('[data-cknav-toggle]');
    if (t) t.setAttribute('aria-expanded', 'true');
    richteAus(item);
  }

  // ---- Maus: Überfahren öffnet, Verlassen schliesst mit Nachlauf ----
  function beiUeberfahren(ereignis) {
    if (!zeigerIstMaus.matches) return;
    if (ereignis.pointerType && ereignis.pointerType !== 'mouse') return;
    var item = naechster(ereignis.target, '[data-cknav-item]');
    window.clearTimeout(schliessZeit);
    if (item) {
      oeffne(item);
    } else if (document.querySelector('.' + OFFEN)) {
      schliessZeit = window.setTimeout(function () { alleSchliessen(null); }, NACHLAUF);
    }
  }
  if (window.PointerEvent) document.addEventListener('pointerover', beiUeberfahren);
  else document.addEventListener('mouseover', beiUeberfahren);

  // ---- Tastatur ----
  // Schliessen nur, wenn der Fokus die Leiste per Tastatur verlaesst. Ein
  // Widget, das sich beim Nachladen selbst den Fokus gibt (Chat, Cookie-Box),
  // darf ein offenes Panel nicht zuklappen.
  document.addEventListener('focusin', function (ereignis) {
    var item = naechster(ereignis.target, '[data-cknav-item]');
    if (item) { oeffne(item); return; }
    var kamAusLeiste = naechster(ereignis.relatedTarget, '.cknav');
    var istInLeiste = naechster(ereignis.target, '.cknav');
    if (kamAusLeiste || istInLeiste) alleSchliessen(null);
  });

  document.addEventListener('keydown', function (ereignis) {
    if (ereignis.key !== 'Escape' && ereignis.key !== 'Esc') return;
    var offen = document.querySelector('.' + OFFEN);
    if (!offen) return;
    var t = offen.querySelector('[data-cknav-toggle]');
    alleSchliessen(null);
    fokus(t);
  });

  // ---- Touch (Tablet, Laptop mit Touchscreen): erster Druck öffnet, zweiter folgt dem Link ----
  document.addEventListener('click', function (ereignis) {
    var knopf = naechster(ereignis.target, '[data-cknav-toggle]');
    if (knopf) {
      var istTouch = ereignis.pointerType === 'touch' || ereignis.pointerType === 'pen' || !zeigerIstMaus.matches;
      if (!istTouch) return;
      var item = naechster(knopf, '[data-cknav-item]');
      if (item && !item.classList.contains(OFFEN)) {
        ereignis.preventDefault();
        oeffne(item);
      }
      return;
    }
    // Nur echte Klicks schliessen. Das Theme loest an anderer Stelle
    // programmatische Klicks aus (Info-Tabs bei Sekunde 5), die sonst ein
    // offenes Panel unter der Maus wegnehmen.
    if (!ereignis.isTrusted) return;
    if (!naechster(ereignis.target, '[data-cknav-item]')) alleSchliessen(null);
  });

  window.addEventListener('resize', function () {
    var offen = document.querySelector('.' + OFFEN);
    if (offen) richteAus(offen);
  });

  /* =====================================================================
     Schublade (Handy und Tablet): Ebenen
     ===================================================================== */

  function schubladeVon(el) { return naechster(el, '.sidebar') || naechster(el, 'sidebar-drawer'); }
  function navVon(el) { return naechster(el, '.cknavm'); }
  function wurzelVon(nav) { return nav.querySelector('[data-cknavm-wurzel]'); }

  function nachOben(nav) {
    var s = schubladeVon(nav);
    if (s) s.scrollTop = 0;
  }

  /* Die Kopfzeile der Ebene läuft unter der Kopfzeile des Themes mit.
     Deren Höhe ist nicht fest, also messen. */
  function kopfMessen(nav) {
    var s = schubladeVon(nav);
    var k = s ? s.querySelector('.sidebar__header') : null;
    nav.style.setProperty('--cknavm-kopf-oben', (k ? k.offsetHeight : 0) + 'px');
  }

  function animiere(panel, klasse) {
    panel.classList.remove('cknavm__panel--rein');
    panel.classList.remove('cknavm__panel--zurueck');
    void panel.offsetWidth; // Neustart der Animation erzwingen
    panel.classList.add(klasse);
  }

  document.addEventListener('animationend', function (ereignis) {
    var panel = ereignis.target;
    if (!panel.classList || !panel.classList.contains('cknavm__panel')) return;
    panel.classList.remove('cknavm__panel--rein');
    panel.classList.remove('cknavm__panel--zurueck');
  });

  function ebeneOeffnen(knopf) {
    var nav = navVon(knopf);
    if (!nav) return;
    var id = knopf.getAttribute('aria-controls');
    var panel = nav.querySelector('[id="' + id + '"]');
    var wurzel = wurzelVon(nav);
    if (!panel || !wurzel) return;

    kopfMessen(nav);
    knopf.setAttribute('aria-expanded', 'true');
    wurzel.hidden = true;
    panel.hidden = false;
    animiere(panel, 'cknavm__panel--rein');
    nachOben(nav);
    fokus(panel.querySelector('[data-cknavm-titel]'));
  }

  function ebeneSchliessen(knopf) {
    var nav = navVon(knopf);
    var panel = naechster(knopf, '.cknavm__panel');
    if (!nav || !panel) return;
    var wurzel = wurzelVon(nav);
    if (!wurzel) return;

    panel.hidden = true;
    wurzel.hidden = false;
    animiere(wurzel, 'cknavm__panel--zurueck');
    nachOben(nav);

    var oeffner = nav.querySelector('[aria-controls="' + panel.id + '"]');
    if (oeffner) {
      oeffner.setAttribute('aria-expanded', 'false');
      fokus(oeffner);
    }
  }

  function gruppeSetzen(knopf, offen) {
    var ziel = document.getElementById(knopf.getAttribute('aria-controls'));
    var gruppe = naechster(knopf, '.cknavm__gruppe');
    knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
    if (ziel) ziel.hidden = !offen;
    if (gruppe) gruppe.classList.toggle('cknavm__gruppe--offen', offen);
  }

  /* Eine Gruppe auf, die Geschwister zu: die Ebene bleibt überschaubar. */
  function gruppeKlappen(knopf) {
    var warOffen = knopf.getAttribute('aria-expanded') === 'true';
    var panel = naechster(knopf, '.cknavm__panel');
    if (panel) {
      var offene = panel.querySelectorAll('[data-cknavm-toggle][aria-expanded="true"]');
      for (var i = 0; i < offene.length; i += 1) gruppeSetzen(offene[i], false);
    }
    if (!warOffen) gruppeSetzen(knopf, true);
  }

  /* Beim Schliessen der Schublade alles auf Anfang: wer sie wieder öffnet,
     landet oben im Hauptmenü, nicht irgendwo in einer Gruppe. */
  function zuruecksetzen(nav) {
    var wurzel = wurzelVon(nav);
    var ebenen = nav.querySelectorAll('.cknavm__panel--ebene');
    for (var i = 0; i < ebenen.length; i += 1) ebenen[i].hidden = true;
    if (wurzel) {
      wurzel.hidden = false;
      wurzel.classList.remove('cknavm__panel--zurueck');
    }
    var oeffner = nav.querySelectorAll('[data-cknavm-open]');
    for (var j = 0; j < oeffner.length; j += 1) oeffner[j].setAttribute('aria-expanded', 'false');
    var gruppen = nav.querySelectorAll('[data-cknavm-toggle]');
    for (var k = 0; k < gruppen.length; k += 1) gruppeSetzen(gruppen[k], false);
  }

  document.addEventListener('click', function (ereignis) {
    var oeffner = naechster(ereignis.target, '[data-cknavm-open]');
    if (oeffner) { ereignis.preventDefault(); ebeneOeffnen(oeffner); return; }

    var zurueck = naechster(ereignis.target, '[data-cknavm-back]');
    if (zurueck) { ereignis.preventDefault(); ebeneSchliessen(zurueck); return; }

    var gruppe = naechster(ereignis.target, '[data-cknavm-toggle]');
    if (gruppe) { ereignis.preventDefault(); gruppeKlappen(gruppe); }
  });

  /* iOS zeigt :active nur, wenn irgendwo ein Touch-Ereignis gehört wird. */
  document.addEventListener('touchstart', function () {}, { passive: true });

  function schubladeBeobachten() {
    var navs = document.querySelectorAll('.cknavm');
    for (var i = 0; i < navs.length; i += 1) {
      (function (nav) {
        var s = schubladeVon(nav);
        if (!s || !window.MutationObserver || s.getAttribute('data-cknavm-beobachtet')) return;
        s.setAttribute('data-cknavm-beobachtet', '1');
        var warOffen = s.classList.contains('sidebar--opened');
        new MutationObserver(function () {
          var istOffen = s.classList.contains('sidebar--opened');
          if (warOffen && !istOffen) {
            window.setTimeout(function () { zuruecksetzen(nav); }, 520);
          }
          warOffen = istOffen;
        }).observe(s, { attributes: true, attributeFilter: ['class'] });
      })(navs[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schubladeBeobachten);
  else schubladeBeobachten();
})();
